import moment from 'moment';
import React from 'react';

export default class extends React.Component {
    static propTypes = {
        languageId: React.PropTypes.number.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            currentTime: new Date()
        };

        this.interval = null;
    }

    componentWillMount() {
        this.interval = setInterval(() => {
            this.setState({
                currentTime: new Date()
            });
        }, 1000);

        this.setState({
            currentTime: new Date()
        });
    }

    componentWillUnmount() {
        if (this.interval !== null) {
            clearInterval(this.interval);
        }
    }

    render() {
        let curTime, timeStr, timeZone;

        curTime = moment(this.state.currentTime);
        timeStr = curTime.format("HH:mm:ss");
        timeZone = curTime.format("Z");

        return (
            <div className='date-time'>
                {timeStr + ' GMT' + timeZone}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./js/sport-betting/components/header/Time.jsx